import React from "react";
import { Popover } from "antd";
import { cities } from "../../constants/commonConstants";

const SubcitiesPopover = ({ cityName }) => {
  // Find the city matching the location
  const matchedCity = cities.find((city) => city.name === cityName);

  // Get the subcities of the matched city (default to empty array if no match)
  const subCities = matchedCity ? matchedCity.subcities : [];
  const content = (
    <div className="px-4 py-2">
      {/* Render subcities */}
      {subCities.map((subCity) => (
        <p key={subCity._id} className="text-content font-inter text-level-7 font-medium leading-6">
          {subCity.name}
        </p>
      ))}
    </div>
  );

  return (
    <Popover content={content} title={null} placement="rightTop" arrow={false} overlayStyle={{ width: "200px" }}>
      <span className="text-content font-inter text-level-7 font-medium leading-6 cursor-pointer">
        {cityName}
      </span>
    </Popover>
  );
};

export default SubcitiesPopover;
